import { graphql } from '~/lib/graphql'

export const GetReservableCalendar = graphql(`
  query getReservableCalendar($restaurantId: RestaurantId!, $input: ReservableCalendarInput!) {
    restaurant(restaurantId: $restaurantId) {
      reservableCalendar(input: $input) {
        ...ReservableCalendarItem
      }
    }
  }
`)
